import dynamic from 'next/dynamic';

/**
 * This dynamically imports `LoginForm` content at the lazily when required.
 * This helps prevent nextjs hydration errors.
 */
const DynamicLoginForm = dynamic(() => import('./LoginForm'), { ssr: false });

export default DynamicLoginForm;
